import { OnGenericPaymentSubmit } from '@/components/purchase/PurchaseForm/types';

import { usePurchaseSubmit } from './usePurchaseSubmit';
import { usePurchaseToken } from './usePurchaseToken';

export interface Gift {
	code: string;
	id: string;
	type: string;
	certificate: string;
}

export type GiftPurchase = {
	gifts: Gift[];
};

interface UseGiftPurchase {
	(): OnGenericPaymentSubmit;
}

export const GIFT_ANALYTICS_PREFIX = 'Gift : Purchase : Form';

export const useGiftPurchase: UseGiftPurchase = () => {
	const onPurchaseSubmit = usePurchaseSubmit();
	const createTokenObject = usePurchaseToken();

	const submitGiftPurchase: OnGenericPaymentSubmit = async ({
		cardInfo,
		userInfo,
		requestInfo,
		email,
		quantity,
		token,
		type,
		coupon,
		paymentType = 'credit_card',
		customerAddress,
	}) => {
		const tokenObject = await createTokenObject({
			paymentType,
			token,
			cardInfo,
			cardData: {
				...userInfo,
				address_state: customerAddress?.region,
				address_zip: customerAddress?.postalCode,
				address_country: customerAddress?.country,
			},
		});

		const purchaseInfo = {
			...requestInfo,
			coupon,
			quantity,
			type,
			email,
			paymentMethod: paymentType === 'paypal' ? 'paypal' : 'stripe',
			customerAddress: {
				postal_code: customerAddress?.postalCode,
				state: customerAddress?.region,
				country: customerAddress?.country,
			},
			...tokenObject,
		};

		return onPurchaseSubmit({
			purchaseInfo,
			paymentType,
			endpoint: 'gift/purchase',
			analyticsPrefix: GIFT_ANALYTICS_PREFIX,
		});
	};

	return submitGiftPurchase;
};
